import { z } from "zod";

export const createPaymentScheduleSchema = (totalAmount: number, lastEditedField: "amount" | "percentage" | null) =>
  z.object({
    paymentSchedule: z
      .array(
        z.object({
          stepId: z.string().optional(),
          amount: z
            .number()
            .min(1, { message: "Amount cannot be negative" })
            .refine((val) => /^\d+(\.\d{1,2})?$/.test(val.toString()), {
              message: "Amount can have max 2 decimal places",
            })
            .optional(),
          days: z.number().int().optional(),
          dueDate: z.string().optional(),
          type: z.enum(["before booking date"]),
          idx: z.number().optional(),
        }),
      )
      .superRefine((arr, ctx) => {
        if (arr.length === 0) return;

        const dynamicTotalAmount = arr.reduce((acc, item) => acc + (item.amount ?? 0), 0);

        arr.forEach((item, index) => {
          if (item.amount === undefined) {
            ctx.addIssue({
              path: [`paymentSchedule.${index}.amount`],
              code: z.ZodIssueCode.custom,
              message: "Percentage is required",
            });
          }
          if (item.days === undefined) {
            ctx.addIssue({
              path: [`paymentSchedule.${index}.days`],
              code: z.ZodIssueCode.custom,
              message: "Days are required",
            });
          }
        });

        if (dynamicTotalAmount === 0) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "Total booking amount cannot be zero.",
          });
          return;
        }
      }),
  });

export type PaymentScheduleForm = z.infer<ReturnType<typeof createPaymentScheduleSchema>>;
